import React from 'react';
import { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router';

import { Subscribe } from 'unstated';

import { ProfileContainer } from './containers/profile-container';
import { SalesHistoryContainer } from './containers/sales-history-container';
import { WineHistoryContainer } from './containers/wine-history-container';
import { ErrorContainer } from './containers/error-container';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { isActiveRoute } from '../lib/routing';

import { getCurrentYear } from '../lib/date-utilities';

import logo from '../assets/images/logo_header.png';

import { Form, Field } from 'react-final-form';

import { FORM_ERROR } from 'final-form';

import { TextInput } from '../components/ui/text-input';
import { TextArea } from '../components/ui/text-area';
import { FormErrors } from '../components/ui/form-errors';
import { DropDown } from '../components/ui/drop-down';

import { required, composeField, phone, email } from '../lib/form-validators';

import { phoneFormatter } from '../lib/form-formatters';
import { phoneParser } from '../lib/form-parsers';

import _ from 'lodash';

import navigation from '../lib/navigation-utilities';

const MenuItems = ({ isActive, className }) => (
  <ul className={className}>
    <li
      className={
        'nav-item ' + (isActive(/^\/account\/wines$/i) ? 'active' : '')
      }
      style={{ width: 'calc(100% / 2)' }}
    >
      <Link
        to="/account/wines"
        className="nav-link text-uppercase text-expanded"
      >
        My Wines
      </Link>
    </li>
    <li
      className={
        'd-none nav-item ' +
        (isActive(/^\/account\/referrals$/i) ? 'active' : '')
      }
      style={{ width: 'calc(100% / 3)' }}
    >
      <Link
        to="/account/referrals"
        className="nav-link text-uppercase text-expanded"
      >
        Free Wine
      </Link>
    </li>
    <li
      className={
        'nav-item ' + (isActive(/^\/account\/profile.*/i) ? 'active' : '')
      }
      style={{ width: 'calc(100% / 2)' }}
    >
      <Link
        to="/account/profile"
        className="nav-link text-uppercase text-expanded"
      >
        My Account
      </Link>
    </li>
  </ul>
);

const ReferAFriend = ({ profileContainer }) => {
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    profileContainer
      .getReferralFactory()
      .then((popup) => {
        // Referral Factory's script reads this when the button is clicked.
        window.referralFactory = { popup };
        setPopup(popup);
      })
      .catch(_.noop);
  }, []);

  return (
    popup && (
      <a
        className="btn btn-secondary btn-l mr-2 text-nowrap referral-factory-popup"
        style={{ cursor: 'pointer', padding: '12px' }}
      >
        REFER A FRIEND{' '}
        <FontAwesomeIcon icon="envelope" size="sm" color="#ffffff" />
      </a>
    )
  );
};

const Main = ({ children, location }) => {
  const [contactModalState, setContactModalState] = useState(false);
  const [contactFormSubmitted, setContactFormSubmitted] = useState(false);

  const logOut =
    (profileContainer, salesHistoryContainer, wineHistoryContainer) => () => {
      salesHistoryContainer.reset();
      wineHistoryContainer.reset();

      const logoutRedirect = () => navigation.replace('/');

      return profileContainer
        .logOut()
        .then(logoutRedirect)
        .catch(logoutRedirect);
    };

  const handleSubmit = (profileContainer) => async (values, form) =>
    profileContainer
      .submitHelpRequest(values)
      .then(() => {
        form.reset();
        setContactFormSubmitted(true);
      })
      .catch(() => {
        return { [FORM_ERROR]: 'Failed to submit message' };
      });

  const expandPanel = window.expandPanel;

  const closePanel = window.closePanel;

  const isActive = isActiveRoute(location);

  return (
    <Subscribe
      to={[
        ProfileContainer,
        SalesHistoryContainer,
        WineHistoryContainer,
        ErrorContainer
      ]}
    >
      {(
        profileContainer,
        salesHistoryContainer,
        wineHistoryContainer,
        errorContainer
      ) => (
        <React.Fragment>
          <nav className="navbar navbar-expand-lg navbar-light dc-header">
            <a className="navbar-brand dc-logo_header" href="/">
              <img src={logo} />
            </a>
            <div className="d-lg-none">
              <a
                onClick={() => expandPanel('#mobileHeaderMenu', 'js-header')}
                href="javascript:void(0)"
              >
                <FontAwesomeIcon
                  icon={['fa', 'ellipsis-v']}
                  size="lg"
                  color="#ae6faf"
                />
              </a>
            </div>
            <div
              className="collapse navbar-collapse position-relative"
              id="headerMenu"
            >
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <a
                    className="nav-link text-uppercase"
                    target="_blank"
                    href="https://www.dcanterwines.com/shop/"
                  >
                    Shop
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link text-uppercase" href="/">
                    Concierge
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-uppercase"
                    target="_blank"
                    href="https://www.dcanterwines.com/event-tickets/"
                  >
                    Classes + Events
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-uppercase"
                    target="_blank"
                    href="https://www.dcanterwines.com/trips/hungary/"
                  >
                    Trips
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-uppercase"
                    target="_blank"
                    href="https://www.dcanterwines.com/services/"
                  >
                    Services
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-uppercase"
                    href="#"
                    target="_blank"
                  >
                    Subscribe
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-uppercase"
                    target="_blank"
                    href="https://www.dcanterwines.com/winelife/"
                  >
                    Wine Life
                  </a>
                </li>
              </ul>
            </div>
          </nav>
          <nav
            className={`dc-mobile-nav d-block d-lg-none`}
            id="mobileHeaderMenu"
          >
            <div className="dc-mobile-nav_list dc-mobile-nav_right">
              <div
                className="dc-mobile-nav_close"
                onClick={() => closePanel('#mobileHeaderMenu', 'js-header')}
              >
                <FontAwesomeIcon
                  icon={['fa', 'times']}
                  size="lg"
                  color="#ffffff"
                />
              </div>
              <ul>
                <li className="">
                  <a
                    className="text-uppercase text-expanded"
                    href="/"
                    onClick={() => closePanel('#mobileHeaderMenu', 'js-header')}
                  >
                    Concierge
                  </a>
                </li>
                <li className="">
                  <a
                    className="text-uppercase text-expanded"
                    target="_blank"
                    href="https://www.dcanterwines.com/event-tickets/"
                    onClick={() => closePanel('#mobileHeaderMenu', 'js-header')}
                  >
                    Classes + Events
                  </a>
                </li>
                <li className="">
                  <a
                    className="text-uppercase text-expanded"
                    target="_blank"
                    href="https://www.dcanterwines.com/trips/hungary/"
                    onClick={() => closePanel('#mobileHeaderMenu', 'js-header')}
                  >
                    Trips
                  </a>
                </li>
                <li className="">
                  <a
                    className="text-uppercase text-expanded"
                    target="_blank"
                    href="https://www.dcanterwines.com/services/"
                    onClick={() => closePanel('#mobileHeaderMenu', 'js-header')}
                  >
                    Services
                  </a>
                </li>
                <li className="">
                  <a
                    className="text-uppercase text-expanded"
                    target="_blank"
                    href="#"
                    onClick={() => closePanel('#mobileHeaderMenu', 'js-header')}
                  >
                    Subscribe
                  </a>
                </li>
                <li className="">
                  <a
                    className="text-uppercase text-expanded"
                    target="_blank"
                    href="https://www.dcanterwines.com/winelife/"
                    onClick={() => closePanel('#mobileHeaderMenu', 'js-header')}
                  >
                    Wine Life
                  </a>
                </li>
              </ul>
            </div>
            <div
              className="dc-mobile-nav_backdrop"
              onClick={() => closePanel('#mobileHeaderMenu', 'js-header')}
            />
          </nav>

          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="profile-section text-right">
                  <div className="dropdown">
                    <a
                      id="my-dropdown"
                      href="#"
                      className="dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      <FontAwesomeIcon icon={['fas', 'user-circle']} /> Hi{' '}
                      {profileContainer.getCurrentProfile() &&
                        profileContainer.getCurrentProfile().firstName}
                    </a>
                    <div className="dropdown-menu dropdown-menu-right">
                      {_.some(profileContainer.getSelectableProfiles()) && (
                        <h4 className="dropdown-header">Profiles</h4>
                      )}
                      {_.map(profileContainer.getSelectableProfiles(), (p) => {
                        return (
                          <div
                            className="dropdown-item"
                            key={p.id}
                            onClick={() =>
                              profileContainer.setCurrentProfileId(p.id)
                            }
                          >
                            {p.fullName}
                            <br />
                            <small>{p.primary ? 'Primary' : 'Secondary'}</small>
                          </div>
                        );
                      })}
                      {_.some(profileContainer.getSelectableProfiles()) && (
                        <div className="dropdown-divider" />
                      )}
                      <div className="dropdown-item">
                        <a
                          onClick={logOut(
                            profileContainer,
                            salesHistoryContainer,
                            wineHistoryContainer
                          )}
                        >
                          Logout
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <nav className="dc-mobile-nav d-block d-lg-none" id="mobileNav">
            <div className="container">
              <a
                href="javascript:void(0)"
                onClick={() => expandPanel('#mobileNav', 'js-nav')}
              >
                <FontAwesomeIcon icon={['fas', 'bars']} size="lg" />
              </a>
            </div>
            <div className="dc-mobile-nav_list">
              <div
                className="dc-mobile-nav_close"
                onClick={() => closePanel('#mobileNav', 'js-nav')}
              >
                <FontAwesomeIcon
                  icon={['fa', 'times']}
                  size="lg"
                  color="#ffffff"
                />
              </div>

              <ul>
                <li className={isActive(/^\/account\/wines$/i) ? 'active' : ''}>
                  <Link
                    to="/account/wines"
                    className="text-uppercase text-expanded"
                    onClick={() => closePanel('#mobileNav', 'js-nav')}
                  >
                    My Wines
                  </Link>
                </li>
                {/* <li
                  className={
                    isActive(/^\/account\/referrals$/i) ? "active" : ""
                  }>
                  <Link
                    to="/account/referrals"
                    className="text-uppercase text-expanded" onClick={() => closePanel("#mobileNav", "js-nav")}>
                    Free Wine
                  </Link>
                </li> */}
                <li
                  className={isActive(/^\/account\/profile.*/i) ? 'active' : ''}
                >
                  <Link
                    to="/account/profile"
                    className="text-uppercase text-expanded"
                    onClick={() => closePanel('#mobileNav', 'js-nav')}
                  >
                    My Account
                  </Link>
                </li>
              </ul>
            </div>
            <div
              className="dc-mobile-nav_backdrop"
              onClick={() => closePanel('#mobileNav', 'js-nav')}
            />
          </nav>
          <nav
            className="navbar navbar-expand-lg d-none d-lg-block"
            id="mainNav"
          >
            <div className="container">
              <div className="collapse navbar-collapse" id="navbarResponsive">
                <MenuItems
                  isActive={isActive}
                  className="navbar-nav mx-auto nav-lg"
                />
              </div>
            </div>
          </nav>

          <section className="page-section clearfix bg-white">
            {children}
          </section>

          <div className="container fixed-bottom pb-3">
            <div
              className={
                'toast' + (errorContainer.hasError() ? ' show' : ' hide')
              }
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
            >
              <div className="toast-header bg-purple text-white">
                <FontAwesomeIcon
                  className="mr-auto"
                  icon={['fas', 'exclamation-circle']}
                />{' '}
                <small>{errorContainer.getOccurredOn()}</small>
                <a
                  className="text-white ml-2 mb-1 close"
                  onClick={() => errorContainer.clearError()}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </a>
              </div>
              <div className="toast-body">{errorContainer.getError()}</div>
            </div>
          </div>

          <div
            className="modal"
            style={{
              display: contactModalState ? 'block' : 'none'
            }}
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
            data-show={contactModalState ? 'true' : 'false'}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content font-primary">
                <div className="modal-header">
                  <h5
                    className="modal-title text-center"
                    id="feedbackLabel"
                    style={{ cursor: 'pointer' }}
                  >
                    Contact Us
                  </h5>

                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setContactModalState(undefined)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div className="modal-body text-center">
                  <div className="bg-white center-block">
                    {contactFormSubmitted ? (
                      <div>
                        <h4>
                          Thanks for your message. Your wine concierge will be
                          in touch soon!
                        </h4>
                        <div
                          className="text-center"
                          style={{ marginTop: '30px' }}
                        >
                          <button
                            className="btn btn-primary btn-wide"
                            onClick={(e) => {
                              setContactFormSubmitted(false);
                              setContactModalState(undefined);
                            }}
                          >
                            CLOSE
                          </button>
                        </div>
                      </div>
                    ) : (
                      [
                        <div
                          style={{ marginTop: '10px', marginBottom: '20px' }}
                        >
                          Leave a note here if you need more wine, have a
                          question, want to update your taste and budget
                          preferences, or simply want to say hi to your wine
                          concierge!
                        </div>,
                        <Form
                          onSubmit={handleSubmit(profileContainer)}
                          render={({
                            handleSubmit,
                            submitting,
                            submitError,
                            dirtySinceLastSubmit
                          }) => (
                            <form onSubmit={handleSubmit}>
                              <div className="row" id="userPassword">
                                <div className="col-md-6">
                                  <Field
                                    name="name"
                                    validate={composeField(required)}
                                    render={TextInput}
                                    placeholder="Name"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <Field
                                    name="email"
                                    validate={composeField(required, email)}
                                    render={TextInput}
                                    placeholder="Email"
                                  />
                                </div>
                                <div className="col-sm-12">
                                  <Field
                                    name="message"
                                    render={TextArea}
                                    placeholder="Comment"
                                  />
                                </div>

                                <div className="col-sm-12">
                                  <FormErrors
                                    submitError={submitError}
                                    dirtySinceLastSubmit={dirtySinceLastSubmit}
                                  />
                                </div>
                                <div className="col-sm-12 text-center mt-4">
                                  <button
                                    className="btn btn-primary btn-wide"
                                    disabled={submitting}
                                  >
                                    SUBMIT
                                  </button>
                                </div>
                              </div>
                            </form>
                          )}
                        />
                      ]
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal-backdrop fade show"
            style={{
              display: contactModalState ? 'block' : 'none'
            }}
          />

          <footer className="footer_section pt-40 pb-40">
            <div className="container">
              <div className="row">
                <div className="col-md-4 col-sm-6">
                  <div className="footer_left">
                    <h3 className="footer_title">DCANTER</h3>
                    <p className="font_20 pb-30">
                      545 8th Street SE
                      <br /> Washington, DC 20003
                    </p>
                    <h3 className="footer_title">CONNECT</h3>
                    <div className="foot_email">
                      <a href="mailto:hello@dcanterwines.com">
                        <strong>hello@dcanterwines.com</strong>
                      </a>
                      <br />
                      (202) 817-3803
                    </div>
                    <div className="so_icon pt-10 pb-30">
                      <ul>
                        <li>
                          <a
                            href="https://www.facebook.com/dcanterwines"
                            title="Facebook"
                            target="_blank"
                          >
                            <em className="fab fa-facebook">&nbsp;</em>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://instagram.com/dcanterwines"
                            title="Instagram"
                            target="_blank"
                          >
                            <em className="fab fa-instagram">&nbsp;</em>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://twitter.com/dcanterwines"
                            title="Twitter"
                            target="_blank"
                          >
                            <em className="fab fa-twitter" />
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="footer_hour">
                      <h3 className="footer_title">HOURS</h3>
                      <p className="font_18">
                        <strong>MON - SAT</strong> 11:00 AM - 9:00 PM
                        <br />
                        <strong>SUN</strong> 12:00 PM - 6:00 PM
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="footer_middle">
                    <h3 className="footer_title">Links</h3>
                    <ul>
                      <li>
                        <a
                          href="https://www.dcanterwines.com/about-us"
                          target="_blank"
                        >
                          About Us
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.dcanterwines.com/jobs"
                          target="_blank"
                        >
                          Jobs
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.dcanterwines.com/faq"
                          target="_blank"
                        >
                          FAQs
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.dcanterwines.com/terms-conditions"
                          target="_blank"
                        >
                          Terms &amp; Conditions
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.dcanterwines.com/shipping"
                          target="_blank"
                        >
                          Delivery Policy
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.dcanterwines.com/privacy-policy"
                          target="_blank"
                        >
                          Privacy Policy
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-4 col-sm-12">
                  <div className="footer_right">
                    <h3 className="footer_title">GET UPDATES</h3>
                    <p className="font_20 pb-20">
                      Join now to receive the most up to date information,
                      classes, events, and more.
                    </p>
                    <div className="newsletter clear">
                      <div id="mc_embed_signup">
                        <form
                          action="//dcanterwines.us5.list-manage.com/subscribe/post?u=93ddc2a1ae4d7752bfbdd01c1&amp;id=edc78c5f25"
                          method="post"
                          id="mc-embedded-subscribe-form"
                          name="mc-embedded-subscribe-form"
                          className="validate"
                          target="_blank"
                          noValidate=""
                        >
                          <div
                            id="mc_embed_signup_scroll"
                            className="form-subscribe footer_subsc"
                          >
                            <div className="input-box">
                              <label
                                style={{ display: 'none' }}
                                htmlFor="mce-EMAIL"
                              >
                                Subscribe to our mailing list
                              </label>
                              <input
                                type="email"
                                name="EMAIL"
                                className="input-text required-entry validate-email"
                                id="mce-EMAIL"
                                placeholder="EMAIL ADDRESS"
                              />

                              <input
                                type="submit"
                                value="SUBSCRIBE"
                                name="subscribe"
                                id="mc-embedded-subscribe"
                                className="button"
                              />
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <h3 className="footer_title pt-30 clear">COPYRIGHT</h3>
                    <p className="font_20">
                      © Copyright DCanter
                      <br /> A Wine Boutique {getCurrentYear()}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="floating-contact-container d-flex">
              <ReferAFriend profileContainer={profileContainer} />
              <a
                className="btn btn-secondary btn-l w-100"
                style={{ cursor: 'pointer', padding: '12px' }}
                onClick={(e) => setContactModalState(true)}
              >
                HELP{' '}
                <FontAwesomeIcon
                  icon={['far', 'comment']}
                  size="sm"
                  color="#ffffff"
                />
              </a>
            </div>
          </footer>
        </React.Fragment>
      )}
    </Subscribe>
  );
};

export default withRouter(Main);
